import { memo, type FC } from 'react';
import { Button } from 'antd';

export interface DashboardControlsProps {
    canStartAllSessions: boolean;
    activeCameraNames: string[];
    hasAnyTransitioningCamera: boolean;
    onStartAll: () => void;
    onStopAll: () => void;
    layoutConfig: {
        buttonWidth: string;
        buttonHeight: string;
        buttonFontSize: string;
        marginTop?: string;
    };
    isMobile?: boolean;
}

export const DashboardControls: FC<DashboardControlsProps> = memo(({
    canStartAllSessions,
    activeCameraNames,
    hasAnyTransitioningCamera,
    onStartAll,
    onStopAll,
    layoutConfig,
    isMobile = false,
}) => {
    const hasActiveCameras = activeCameraNames.length > 0;

    const containerStyle = isMobile
        ? {
            textAlign: 'center' as const,
            paddingTop: 'clamp(8px, 2vh, 22px)',
            paddingBottom: 'clamp(8px, 2vh, 20px)',
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
        }
        : {
            textAlign: 'center' as const,
            marginTop: layoutConfig.marginTop,
            paddingBottom: '24px',
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
        };

    return (
        <div style={containerStyle}>
            {canStartAllSessions && (
                <Button
                    type="primary"
                    size="large"
                    onClick={onStartAll}
                    disabled={!canStartAllSessions || hasAnyTransitioningCamera}
                    style={{
                        width: layoutConfig.buttonWidth,
                        height: layoutConfig.buttonHeight,
                        fontSize: layoutConfig.buttonFontSize,
                        fontWeight: '600',
                        background: 'rgba(52, 199, 89, 0.32)',
                        border: 'none',
                        color: '#34C759',
                        borderRadius: '8px',
                        opacity: !canStartAllSessions || hasAnyTransitioningCamera ? 0.5 : 1,
                    }}
                >
                    Start All
                </Button>
            )}
            {!canStartAllSessions && (
                <Button
                    danger
                    size="large"
                    onClick={onStopAll}
                    disabled={!hasActiveCameras || hasAnyTransitioningCamera}
                    style={{
                        width: layoutConfig.buttonWidth,
                        height: layoutConfig.buttonHeight,
                        fontSize: layoutConfig.buttonFontSize,
                        fontWeight: '600',
                        background:
                            !hasActiveCameras || hasAnyTransitioningCamera ? '#5a2f2f' : 'rgba(255, 59, 48, 0.32)',
                        border: 'none',
                        color: '#FF3B30',
                        borderRadius: '8px',
                        opacity: !hasActiveCameras || hasAnyTransitioningCamera ? 0.5 : 1,
                    }}
                >
                    Stop All
                </Button>
            )}
        </div>
    );
});

DashboardControls.displayName = 'DashboardControls';
